import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Container from "public-components/Container";
import { Store } from "public-components/StoreProvider";
import backgroundStyles from "styles/background.module.scss";
import styles from "./AdSection.module.scss";

const AD = ({ adDivId, adId }) => {
  React.useEffect(() => {
    if (!window.googletag) return;
    window.googletag.cmd.push(() => {
      window.googletag.pubads().display(adId, [728, 90], adDivId);
    });
  }, [adDivId, adId]);

  return <div id={adDivId} className={styles.adBlock} />;
};

const AdSection = ({ data }) => {
  const { state } = React.useContext(Store);

  return (
    <div
      className={classnames(
        styles.adSection,
        backgroundStyles[data.backgroundColor] || backgroundStyles.white
      )}
      style={{ display: state.isVip ? "none" : null }}
    >
      <Container>
        <div
          className={classnames(
            styles.ad,
            data.adSectionBorderPosition === "top" ? styles.borderTop : null,
            data.adSectionBorderPosition === "bottom" ? styles.borderBottom : null
          )}
        >
          <AD adDivId={data.adType[0].adDivId} adId={data.adType[0].adId} />
        </div>
      </Container>
    </div>
  );
};

AdSection.propTypes = {
  data: PropTypes.shape({
    adType: PropTypes.arrayOf(PropTypes.object).isRequired,
    adSectionBorderPosition: PropTypes.string,
    backgroundColor: PropTypes.string
  }).isRequired
};

export default AdSection;
export { AD };
